"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REARequestKeyStatusEnum = exports.CoBrokeStatusEnum = exports.PackageCategory = exports.Category = void 0;
var Category;
(function (Category) {
    Category[Category["Property"] = 0] = "Property";
    Category[Category["VacantPossession"] = 1] = "VacantPossession";
    Category[Category["DefectInspection"] = 2] = "DefectInspection";
    Category[Category["DesignRenovation"] = 3] = "DesignRenovation";
    Category[Category["PropertyManagement"] = 4] = "PropertyManagement";
    Category[Category["LeaseSale"] = 5] = "LeaseSale";
    Category[Category["VacantManagement"] = 6] = "VacantManagement";
    Category[Category["User"] = 7] = "User";
    Category[Category["BankTransfer"] = 8] = "BankTransfer";
    Category[Category["Wallet"] = 9] = "Wallet";
    Category[Category["REN"] = 10] = "REN";
    Category[Category["CoBroke"] = 11] = "CoBroke";
    Category[Category["PendingSignature"] = 12] = "PendingSignature";
    Category[Category["PropertyManagementTransaction"] = 13] = "PropertyManagementTransaction";
    Category[Category["PropertyGroup"] = 14] = "PropertyGroup";
})(Category = exports.Category || (exports.Category = {}));
var PackageCategory;
(function (PackageCategory) {
    PackageCategory[PackageCategory["VacantPossession"] = 1] = "VacantPossession";
    PackageCategory[PackageCategory["DefectInspection"] = 2] = "DefectInspection";
    PackageCategory[PackageCategory["DesignRenovation"] = 3] = "DesignRenovation";
    PackageCategory[PackageCategory["PropertyManagement"] = 4] = "PropertyManagement";
    PackageCategory[PackageCategory["LeaseSale"] = 5] = "LeaseSale";
    PackageCategory[PackageCategory["VacantManagement"] = 6] = "VacantManagement";
})(PackageCategory = exports.PackageCategory || (exports.PackageCategory = {}));
var CoBrokeStatusEnum;
(function (CoBrokeStatusEnum) {
    CoBrokeStatusEnum[CoBrokeStatusEnum["Pending"] = 0] = "Pending";
    CoBrokeStatusEnum[CoBrokeStatusEnum["Approved"] = 1] = "Approved";
    CoBrokeStatusEnum[CoBrokeStatusEnum["Rejected"] = 2] = "Rejected";
})(CoBrokeStatusEnum = exports.CoBrokeStatusEnum || (exports.CoBrokeStatusEnum = {}));
var REARequestKeyStatusEnum;
(function (REARequestKeyStatusEnum) {
    REARequestKeyStatusEnum[REARequestKeyStatusEnum["Pending"] = 0] = "Pending";
    REARequestKeyStatusEnum[REARequestKeyStatusEnum["Approved"] = 1] = "Approved";
    REARequestKeyStatusEnum[REARequestKeyStatusEnum["Rejected"] = 2] = "Rejected";
})(REARequestKeyStatusEnum = exports.REARequestKeyStatusEnum || (exports.REARequestKeyStatusEnum = {}));
